/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ population: NonNullable<unknown> }} City_PopulationInputs */



/**
* | output |
* | --- |
* | "Population: {population}" |
*
* @param {City_PopulationInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const city_population = /** @type {((inputs: City_PopulationInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<City_PopulationInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Population : ${i?.population}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Población: ${i?.population}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`População: ${i?.population}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Popolazione: ${i?.population}`)
	return /** @type {LocalizedString} */ (`Population: ${i?.population}`)
});